import Analytics from './analytics';

let windowSizeCache = $(window).width() < 768;

/**
 * @param {Object} element Element
 * @param {String} scrollOnThreeFourth Position of the scroll
 * @returns {Boolean}
 */
function checkIfElementIsVisible(element, scrollOnThreeFourth) { // eslint-disable-line
  if (element.offset()) {
    const elementScrollPosition = element.offset().top;
    return scrollOnThreeFourth > elementScrollPosition;
  }
}

/**
 * @param {String} scrollOnThreeFourth Position of the scroll
 * @param {Object} element Element
 * @param {Function} functionToRun Function to run
 */
function startSingleEvent(scrollOnThreeFourth, element, functionToRun) {
  const elementIsVisible = checkIfElementIsVisible(element, scrollOnThreeFourth);

  if (elementIsVisible) {
    if (!element.hasClass('element-showed')) {
      element.addClass('element-showed');
      functionToRun();
    }
  }
}

/**
 */
function startSomeFunction() {
  console.log('Element is visible'); // eslint-disable-line
}

/**
 */
function startAllEvents() {
  const windowScrollPosition = $(window).scrollTop();
  const windowThreeFourth = ($(window).height() / 4) * 3;
  const scrollOnThreeFourth = windowScrollPosition + windowThreeFourth;
  startSingleEvent(scrollOnThreeFourth, $('.some-element'), startSomeFunction);
}

export default class WindowEvents {
  static init() {
    $(window).on('scroll', WindowEvents.onScroll).on('resize', WindowEvents.onResize);
  }

  static onScroll() {
    startAllEvents();
    Analytics.pageViewed();
  }

  static onResize() {
    const $window = $(this);
    const isMobile = $window.width() < 768;
    const deviceChanged = windowSizeCache !== isMobile;

    if (deviceChanged) {
      const isGoingToMobile = $window.width() < 768;
      if (isGoingToMobile) {
        console.log('Window changed to mobile'); // eslint-disable-line
      } else {
        console.log('Window changed to desktop'); // eslint-disable-line
      }
      windowSizeCache = $(window).width() < 768;
    }
  }
}



// WEBPACK FOOTER //
// local_static/templates/guias/2018/assets/scripts/windowEvents.js